import { render, staticRenderFns } from "./MaterialEditPage.vue?vue&type=template&id=4362144a&scoped=true"
import script from "./MaterialEditPage.vue?vue&type=script&lang=ts"
export * from "./MaterialEditPage.vue?vue&type=script&lang=ts"
import style0 from "./MaterialEditPage.vue?vue&type=style&index=0&id=4362144a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4362144a",
  null
  
)

export default component.exports